//GLOBAL - components from npm
import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, useFilters } from "react-table";
import { ReactComponent as FavoriteIcon } from "../../build/images/icons/favoritetwo.svg";
import { ReactComponent as FavoriteEnableIcon } from "../../build/images/star.svg";
import { ReactComponent as LeadIcon } from "../../build/images/icons/leadmail.svg";
import { ReactComponent as SmsIcon } from "../../build/images/smsgrain.svg";
import { ReactComponent as EmptyState } from "../../build/images/emptystatemanagerhorizontal.svg";
// import { format } from "date-fns";
import { createTheme, useTheme } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import OrderButton from "../order-button/OrderButton";

//STYLES
import "./table-back-pagination.css";
import NewPaginationV3 from "../NewPaginationV3/NewPaginationV3";
import Paperplane from "../Loading/Paperplane";

export default function TableBackPagination({
  className = "",
  data,
  columns,
  fixedHeader,
  fixedFirstColumn,
  filtersActive,
  emptyState = false,
  setEmptyState = () => null,
  controlledTableState,
  screen = "",
  initialState,
  rowShadowLine = false,
  classDivWrapperTable = null,
  totalOfRows,
  setRowsPage,
  rowsPage,
  setPageOfTable,
  pageOfTable,
  isloading,
  onChangePage,
  onChangeRowsPerPage,
  isDisabled,
  ...others
}) {
  // DEFAULT PROPS
  const defaultData = useMemo(() => [], []);

  //GENERAL
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setFilter,
  } = useTable(
    {
      columns,
      data,
      useControlledState: (state) => {
        // console.debug('state: ', state);
        return {
          ...state,
          ...controlledTableState,
        };
      },
      initialState: initialState,
    },
    useFilters,
    useSortBy
  );

  const theme = useTheme();
  let checkMarkBox = false;

  //STATES
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const countPagination =
    parseInt(rows.length / rowsPerPage) +
    (rows.length % rowsPerPage !== 0 ? 1 : 0);
  // const [testeRoll, setTesteRoll] = useState("");

  //REDUX - Selectors
  // const dispatch = useDispatch();

  //FUNCTIONS

  const themeWithLocale = React.useMemo(
    () => createTheme(theme, ptBR),
    [ptBR, theme]
  );

  const displayHeader = (head) => {
    return head.display !== false;
  };

  const displayBody = (body) => {
    return body.column.display !== false;
  };

  function renderCellContent(cell, row, index) {
    if (cell.value) {
      if (cell.column.id === "actions_primary") {
        return (
          <div className="cell-content__container">
            <input
              type="checkbox"
              id={"cell" + index}
              className="cell-content__container-checkbox"
            />
            <div className="cell-content__container-icon">
              {row.values.actions_primary.config.favorite ? (
                <FavoriteEnableIcon />
              ) : (
                <FavoriteIcon />
              )}
            </div>
          </div>
        );
      } else if (cell.column.id === "actions_secondary") {
        return (
          <div className="cell-content__container">
            {/* <TrashIcon /> */}
            <div className="cell-content__container-icon">
              {row.values.actions_primary.config.read ? (
                <LeadIcon />
              ) : (
                <SmsIcon />
              )}
            </div>
          </div>
        );
      } else if (
        cell.column.id === "sender" ||
        cell.column.id === "recipient" ||
        cell.column.id === "copy"
      ) {
        return (
          <span>
            {cell.value.data !== "" &&
            cell.value.data !== "null" &&
            cell.value.data !== null
              ? cell.value.data[0].toUpperCase() + cell.value.data.substring(1)
              : ""}
          </span>
        );
      } else {
        if (
          screen === "manager" ||
          screen === "manager_colaborators" ||
          screen === "manager_operators" ||
          screen === "manager_groupRow" ||
          screen === "campaigns"
        ) {
          return (
            <span
              className={
                cell.value.config.className
                  ? cell.value.config.className
                  : "cell-gray-text"
              }
            >
              {cell.value.data}
            </span>
          );
        } else {
          return <span>{cell.value.data}</span>;
        }
      }
    } else {
      return "";
    }
  }

  function renderCell(row, index) {
    saveSortDesc(headerGroups);
    return row.cells.filter(displayBody).map((cell) => {
      if (cell.value && cell.value.config && cell.value.config.cellColor) {
        return (
          <td
            {...cell.getCellProps()}
            className={`cell-ellipsis ${
              cell.value.config.cellColor ? cell.value.config.cellColor : ""
            }`}
          >
            <div className="cell-container">
              {renderCellContent(cell, row, index)}
            </div>
          </td>
        );
      } else {
        return (
          <td {...cell.getCellProps()} className="cell-ellipsis">
            <div className="cell-container">
              {renderCellContent(cell, row, index)}
            </div>
          </td>
        );
      }
    });
  }

  function checkEmptyState() {
    if (!emptyState && rows.length === 0) {
      setEmptyState(true);
    } else if (emptyState && rows.length > 0) {
      setEmptyState(false);
    }
  }

  checkEmptyState();
  // #TOIMPROVE: remover a função de checar o empty state se conseguir ter acesso aos estado atual das linhas (após filtrado) fora do component table

  //USE EFFECTS
  useEffect(() => {
    if (screen === "npsTables" || screen === "campaigns") {
      setPage(0);
    }
  }, [rows.length]);

  useEffect(() => {
    let element = document.getElementById("mark_all_inputs");
    if (element) {
      element.addEventListener("click", function () {
        for (
          let i = 0;
          i <
          document.getElementsByClassName("cell-content__container-checkbox")
            .length;
          i++
        ) {
          if (document.getElementById(`cell${i}`)) {
            if (checkMarkBox)
              document.getElementsByClassName(
                "cell-content__container-checkbox"
              )[i].checked = false;
            else
              document.getElementsByClassName(
                "cell-content__container-checkbox"
              )[i].checked = true;
          }
        }
        checkMarkBox = !checkMarkBox;
      });
    }
    let rowsPerPage = 5;
    if (screen === "manager_colaborators") {
      rowsPerPage = localStorage.getItem("rows_perpage_colaborators");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "manager") {
      rowsPerPage = localStorage.getItem("rows_perpage_services");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "manager_operators") {
      rowsPerPage = localStorage.getItem("rows_perpage_operators");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "manager_groupRow") {
      rowsPerPage = localStorage.getItem("rows_perpage_groupRow");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "npsTables") {
      rowsPerPage = localStorage.getItem("rows_perpage_npsTables");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "campaigns") {
      rowsPerPage = localStorage.getItem("rows_perpage_campaigns");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    }
  }, []);

  function saveSortDesc(headerGroups) {
    if (headerGroups.length !== 0) {
      let findSort = headerGroups[0].headers.filter(
        (group) => group.isSorted === true
      );
      if (findSort.length !== 0) {
        let sortMarked = {
          sort: findSort[0].id,
          sortDesc: findSort[0].isSortedDesc,
        };

        screen === "manager" &&
          localStorage.setItem("sortMarkedService", JSON.stringify(sortMarked));
        screen === "manager_colaborators" &&
          localStorage.setItem(
            "sortMarkedColaborators",
            JSON.stringify(sortMarked)
          );
        screen === "manager_operators" &&
          localStorage.setItem(
            "sortMarkedOperators",
            JSON.stringify(sortMarked)
          );
        screen === "manager_groupRow" &&
          localStorage.setItem(
            "sortMarkedGroupRow",
            JSON.stringify(sortMarked)
          );
        screen === "npsTables" &&
          localStorage.setItem("sortDealingRow", JSON.stringify(sortMarked));
        screen === "campaigns" &&
          localStorage.setItem("sortCampaigns", JSON.stringify(sortMarked));
      } else {
        screen === "manager" && localStorage.removeItem("sortMarkedService");
        screen === "manager_colaborators" &&
          localStorage.removeItem("sortMarkedColaborators");
        screen === "manager_operators" &&
          localStorage.removeItem("sortMarkedOperators");
        screen === "manager_groupRow" &&
          localStorage.removeItem("sortMarkedGroupRow");
        screen === "npsTables" && localStorage.removeItem("sortDealingRow");
        screen === "campaigns" && localStorage.removeItem("sortCampaigns");
      }
    }
  }

  const renderTable = () => {
    if (isloading) {
      return (
        <div className={`section-email-list ${className ? className : ""}`}>
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Paperplane />
          </div>
          <div>
            <NewPaginationV3
              totalItems={totalOfRows ? totalOfRows : 0}
              setRowsPage={setRowsPage}
              rowsPage={rowsPage}
              itemsPerPage={rowsPage}
              setPageOfTable={setPageOfTable}
              pageOfTable={pageOfTable}
              rowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
            />
          </div>
        </div>
      );
    }

    const hasData = !!data && Array.isArray(data) && data.length > 0;
    if (hasData) {
      return (
        <div className={`section-email-list ${className ? className : ""}`}>
          <div className={classDivWrapperTable ? classDivWrapperTable : ""}>
            <table
              className="table mail table--fixed-first-column"
              {...getTableProps()}
              cellSpacing={0}
              {...others}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.filter(displayHeader).map((column) => {
                      return (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps({
                              title: column.Hint,
                            })
                          )}
                        >
                          <div className={`flex-container`}>
                            <span className="table-header__title">
                              {column.render("Header")}
                            </span>
                            {column.canSort && (
                              <OrderButton
                                direction={
                                  column.isSorted &&
                                  (column.isSortedDesc ? "desc" : "asc")
                                }
                              />
                            )}
                          </div>
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {className !== "table-email"
                  ? rows.map((row, index) => {
                      prepareRow(row);
                      if (row.values.actions_primary)
                        return (
                          <tr
                            className={`${
                              row.values.actions_primary.config.read
                                ? "read"
                                : "unread"
                            } ${rowShadowLine ? "shadow-line" : ""}`}
                            {...row.getRowProps()}
                          >
                            {renderCell(row, index)}
                          </tr>
                        );
                      else
                        return (
                          <tr
                            className={`${rowShadowLine ? "shadow-line" : ""}`}
                            {...row.getRowProps()}
                          >
                            {renderCell(row, index)}
                          </tr>
                        );
                    })
                  : rows.map((row, index) => {
                      prepareRow(row);
                      if (row.values.actions_primary)
                        return (
                          <tr
                            className={`${
                              row.values.actions_primary.config.read
                                ? "read"
                                : "unread"
                            } ${rowShadowLine ? "shadow-line" : ""}`}
                            {...row.getRowProps()}
                          >
                            {renderCell(row, index)}
                          </tr>
                        );
                      else
                        return (
                          <tr
                            className={`${rowShadowLine ? "shadow-line" : ""}`}
                            {...row.getRowProps()}
                          >
                            {renderCell(row, index)}
                          </tr>
                        );
                    })}
              </tbody>
            </table>
          </div>
          <div>
            <NewPaginationV3
              totalItems={totalOfRows ? totalOfRows : 0}
              setRowsPage={setRowsPage}
              rowsPage={rowsPage}
              itemsPerPage={rowsPage}
              setPageOfTable={setPageOfTable}
              pageOfTable={pageOfTable}
              rowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
              isDisabled={isDisabled}
            />
          </div>
        </div>
      );
    }

    return (
      <div className="dealing-card__table-container__emptyState">
        <EmptyState />
      </div>
    );
  };

  return renderTable();
}
